(function () {
  if (window.__sawayGalleryNativeInit) return;
  window.__sawayGalleryNativeInit = true;

  var mobileMql = window.matchMedia('(max-width: 767px)');

  function moveChildren(from, to) {
    while (from.firstChild) to.appendChild(from.firstChild);
  }

  // Replace an xo custom element with a plain div, copying class/style/data
  // attributes so the theme CSS keeps applying. Returns the new div.
  function toDiv(el, extraClass) {
    var div = document.createElement('div');
    var cls = el.getAttribute('class');
    div.className = cls ? cls + ' ' + extraClass : extraClass;
    var style = el.getAttribute('style');
    if (style) div.setAttribute('style', style);
    var mediaId = el.getAttribute('data-media-id');
    if (mediaId) div.setAttribute('data-media-id', mediaId);
    moveChildren(el, div);
    return div;
  }

  function slideOffsets(inner, slides) {
    var innerRect = inner.getBoundingClientRect();
    var current = inner.scrollLeft;
    var max = inner.scrollWidth - inner.clientWidth;
    var offsets = [];
    for (var i = 0; i < slides.length; i++) {
      var left = slides[i].getBoundingClientRect().left - innerRect.left + current;
      if (left < 0) left = 0;
      if (left > max) left = max;
      offsets.push(left);
    }
    return offsets;
  }

  function nearestIndex(inner, slides) {
    var offsets = slideOffsets(inner, slides);
    var current = inner.scrollLeft;
    var idx = 0;
    var min = Infinity;
    for (var i = 0; i < offsets.length; i++) {
      var d = Math.abs(offsets[i] - current);
      if (d < min) {
        min = d;
        idx = i;
      }
    }
    return idx;
  }

  function migrateGallery(carousel) {
    if (carousel.dataset.sawayGalReady === '1') return;

    var oldInner = carousel.querySelector(
      '.xo-product-info-media-mobile__top > xo-carousel-inner'
    );
    if (!oldInner) return;
    var oldList = oldInner.querySelector('xo-carousel-list');
    if (!oldList) return;

    carousel.dataset.sawayGalReady = '1';
    carousel.classList.add('saway-gal-active');

    // --- Main slides -> native scroll-snap container ---
    var inner = document.createElement('div');
    inner.className = 'saway-gal-inner';
    var list = document.createElement('div');
    list.className = 'saway-gal-list';

    var oldSlides = oldList.querySelectorAll('xo-carousel-slide:not([xo-cloned])');
    var slides = [];
    for (var i = 0; i < oldSlides.length; i++) {
      var slide = toDiv(oldSlides[i], 'saway-gal-slide');
      list.appendChild(slide);
      slides.push(slide);
    }
    inner.appendChild(list);
    oldInner.parentNode.replaceChild(inner, oldInner);

    // --- Thumbnails -> native horizontal scroll strip ---
    var thumbs = [];
    var thumbInner = null;
    var oldThumbWrap = carousel.querySelector('xo-carousel-thumbnail');
    if (oldThumbWrap) {
      var thumbWrap = toDiv(oldThumbWrap, 'saway-thumb-wrap');
      var oldThumbInner = thumbWrap.querySelector('xo-carousel-inner');
      var oldThumbList = oldThumbInner && oldThumbInner.querySelector('xo-carousel-list');
      if (oldThumbList) {
        thumbInner = document.createElement('div');
        thumbInner.className = 'saway-thumb-inner';
        var thumbList = document.createElement('div');
        thumbList.className = 'saway-thumb-list';
        var oldThumbs = oldThumbList.querySelectorAll('xo-carousel-slide:not([xo-cloned])');
        for (var j = 0; j < oldThumbs.length; j++) {
          var thumb = toDiv(oldThumbs[j], 'saway-thumb-slide');
          thumbList.appendChild(thumb);
          thumbs.push(thumb);
        }
        thumbInner.appendChild(thumbList);
        oldThumbInner.parentNode.replaceChild(thumbInner, oldThumbInner);
      }
      oldThumbWrap.parentNode.replaceChild(thumbWrap, oldThumbWrap);
    }

    // --- Pagination -> simple dots (used when thumbnail_mobile = pagination) ---
    var dots = [];
    var oldPag = carousel.querySelector('xo-carousel-pagination');
    if (oldPag) {
      var pag = toDiv(oldPag, 'saway-gal-pagination');
      if (slides.length > 1) {
        for (var k = 0; k < slides.length; k++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'saway-gal-dot';
          dot.setAttribute('aria-label', String(k + 1));
          dot.innerHTML = '<span class="xo-product-info-media-mobile__bullet"></span>';
          pag.appendChild(dot);
          dots.push(dot);
        }
      }
      oldPag.parentNode.replaceChild(pag, oldPag);
    }

    // Thumbnails show 5 per view like the original (xo-per-view=5, 1rem gap).
    function sizeThumbs() {
      if (!thumbInner || !thumbs.length) return;
      var per = Math.min(5, Math.max(1, thumbs.length));
      var gap = 10;
      var w = (thumbInner.clientWidth - gap * (per - 1)) / per;
      if (w <= 0) return;
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].style.width = w + 'px';
      }
    }
    sizeThumbs();
    window.addEventListener('resize', sizeThumbs);

    function setActive(idx) {
      for (var i = 0; i < thumbs.length; i++) {
        if (i === idx) {
          thumbs[i].setAttribute('xo-active', '');
        } else {
          thumbs[i].removeAttribute('xo-active');
        }
      }
      for (var d = 0; d < dots.length; d++) {
        if (d === idx) {
          dots[d].setAttribute('xo-active', '');
        } else {
          dots[d].removeAttribute('xo-active');
        }
      }
      // Keep the active thumbnail visible inside its own strip.
      if (thumbInner && thumbs[idx]) {
        var t = thumbs[idx];
        var left = t.offsetLeft;
        var right = left + t.offsetWidth;
        if (left < thumbInner.scrollLeft) {
          thumbInner.scrollTo({ left: left, behavior: 'smooth' });
        } else if (right > thumbInner.scrollLeft + thumbInner.clientWidth) {
          thumbInner.scrollTo({
            left: right - thumbInner.clientWidth,
            behavior: 'smooth',
          });
        }
      }
    }
    setActive(0);

    var ticking = false;
    inner.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          setActive(nearestIndex(inner, slides));
        });
      },
      { passive: true }
    );

    function goTo(idx, smooth) {
      if (idx < 0 || idx >= slides.length) return;
      var offsets = slideOffsets(inner, slides);
      inner.scrollTo({
        left: offsets[idx],
        behavior: smooth === false ? 'auto' : 'smooth',
      });
    }

    for (var ti = 0; ti < thumbs.length; ti++) {
      (function (idx) {
        thumbs[idx].addEventListener('click', function () {
          goTo(idx);
        });
      })(ti);
    }
    for (var di = 0; di < dots.length; di++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          goTo(idx);
        });
      })(di);
    }

    // Exposed for variant featured-media sync below.
    carousel.__sawayGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
          goTo(i);
          return;
        }
      }
    };
  }

  function migrateAll() {
    if (!mobileMql.matches) return;
    var carousels = document.querySelectorAll(
      'xo-carousel[data-saway-native-gallery]'
    );
    for (var i = 0; i < carousels.length; i++) {
      migrateGallery(carousels[i]);
    }
  }

  // Variant change -> jump to that variant's featured media, replicating what
  // main.js does through xoCarousel.goTo for the untouched xo carousel.
  function parseProductData(text) {
    try {
      var t = (text || '').trim();
      if (!/^{|\[/.test(t)) return null;
      var data = new Function('return ' + t)();
      return JSON.parse(JSON.stringify(data));
    } catch (e) {
      return null;
    }
  }

  var variantBound = false;
  function bindVariantSync() {
    if (variantBound) return;
    if (
      typeof window.cartFormSubscribe !== 'function' ||
      typeof window.getCartFormState !== 'function'
    ) {
      return;
    }
    var info = document.querySelector('xo-product[xo-product-information]');
    if (!info) return;
    var dataEl = info.querySelector('xo-product-data script');
    var productData = dataEl && parseProductData(dataEl.textContent);
    if (!productData || !productData.variants) return;

    variantBound = true;
    var lastSelected = null;
    window.cartFormSubscribe(function () {
      var key =
        info.getAttribute('xo-section-id') +
        '/' +
        info.getAttribute('xo-product-id');
      var state = window.getCartFormState();
      var formState = state && state[key];
      if (!formState || !formState.variantSelected) return;
      var selected = JSON.stringify(
        Object.values(formState.variantSelected).slice().sort()
      );
      if (selected === lastSelected) return;
      lastSelected = selected;

      var variant = null;
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        if (JSON.stringify((v.options || []).slice().sort()) === selected) {
          variant = v;
          break;
        }
      }
      var mediaId =
        variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;

      var carousels = document.querySelectorAll(
        'xo-carousel[data-saway-native-gallery]'
      );
      for (var c = 0; c < carousels.length; c++) {
        if (typeof carousels[c].__sawayGoToMedia === 'function') {
          carousels[c].__sawayGoToMedia(mediaId);
        }
      }
    });
  }

  function init() {
    migrateAll();
    bindVariantSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  // Window resized/rotated from desktop into mobile after load: migrate then.
  if (typeof mobileMql.addEventListener === 'function') {
    mobileMql.addEventListener('change', function (e) {
      if (e.matches) init();
    });
  }

  // Kill any residual xo touch handlers for migrated galleries, but let
  // multi-touch through untouched so mobile-pinch-zoom.js (document-level
  // listeners) keeps working. touchend/touchcancel are never blocked so the
  // pinch reset always runs; xo's own touchend is a no-op when it never saw
  // the touchstart.
  ['touchstart', 'touchmove'].forEach(function (type) {
    document.addEventListener(
      type,
      function (e) {
        if (e.touches && e.touches.length >= 2) return;
        var c =
          e.target &&
          e.target.closest &&
          e.target.closest('xo-carousel[data-saway-native-gallery]');
        if (!c || c.dataset.sawayGalReady !== '1') return;
        e.stopImmediatePropagation();
      },
      { capture: true, passive: true }
    );
  });
})();
